"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var API_URLS = {
  test: "https://publishing-content.redge.globalqa.aws-usw2-dev.dev.rc.rcluster.io",
  preview: "https://publishing-content.redge.globalqa.aws-usw2-dev.staging.rc.rcluster.io",
  live: "https://content.publishing.riotgames.com"
};
var NA_LOCALES = ["en-us", "es-mx", "pt-br", "es-ar"];
var EU_LOCALES = ["ar-ae", "cs-cz", "de-de", "en-gb", "en-pl", "es-es", "fr-fr", "hu-hu", "it-it", "pl-pl", "ro-ro", "ru-ru", "tr-tr"];
var SEA_LOCALES = ["en-au", "en-sg", "en-ph", "id-id", "ms-my", "zh-tw", "vi-vn"];
var ASIA_LOCALES = ["ja-jp", "ko-kr", "zh-cn"];
var _default = function _default(apiInfo) {
  switch (apiInfo.environment) {
    case "test":
      return API_URLS.test;
    case "preview":
      return API_URLS.preview;
    default:
      return API_URLS.live;
  }
};
exports.default = _default;